// Input rules
export const numberInput = { pattern: '^[0-9]*$' }

export const salesPointCodeInput = { pattern: '^[0-9]{6}$' }

export const zipCodeInput = { pattern: `^[0-9][0-9AB]?[0-9]{3}$` }
